module.exports = __webpack_public_path__ + "./logo.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./logo.png!./src/img/smash-icon.png
// module id = 2508
// module chunks = 0